import React, { useEffect, useState } from "react";

const AvatarCard = ({ item, styles }) => {
  const baseUrl = process.env.REACT_APP_API_URL;

  const [coloumValue, setColoumValue] = useState(JSON.parse(item?.coloum_value));
const [stylesColoumValue, setStylesColoumValue] = useState(null);
const [avatarStyles, setAvatarStyles] = useState(null);

useEffect(() => {
  setColoumValue(JSON.parse(item?.coloum_value));
  const avatar_styles = styles?.filter(
      (item) => item?.coloum_name === "avatar"
    )?.[0] || null;
  setAvatarStyles(avatar_styles);
}, [item, styles])

useEffect(() => {
  const styles_coloum_value = avatarStyles?.coloum_value && JSON.parse(avatarStyles?.coloum_value);
    setStylesColoumValue(styles_coloum_value);
}, [item, styles, avatarStyles])


  return (
    <div className="flex justify-center">
      <img
      style={{ borderStyle : stylesColoumValue?.avatar_outline?.outline_style, borderColor:stylesColoumValue?.avatar_outline?.outline_colour }}
        className={`object-cover ${
          stylesColoumValue?.avatar_size
            ? stylesColoumValue?.avatar_size === "75x75"
              ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
              : stylesColoumValue?.avatar_size === "100x100"
              ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
              : stylesColoumValue?.avatar_size === "125x125"
              ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
              : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
            : coloumValue?.size === "75x75"
            ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
            : coloumValue?.size === "100x100"
            ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
            : coloumValue?.size === "125x125"
            ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
            : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
        } ${
          stylesColoumValue?.avatar_shape
            ? stylesColoumValue?.avatar_shape === "rounded"
              ? "rounded-lg"
              : stylesColoumValue?.avatar_shape === "circle"
              ? "rounded-full"
              : "rounded-none"
            : coloumValue?.radius === "rounded"
            ? "rounded-lg"
            : coloumValue?.radius === "circle"
            ? "rounded-full"
            : "rounded-none"
        } ${
          stylesColoumValue?.avatar_outline
            ? `${
                stylesColoumValue?.avatar_outline?.outline_width === "8px"
                  ? "border-8"
                  : stylesColoumValue?.avatar_outline?.outline_width === "4px"
                  ? "border-4"
                  : stylesColoumValue?.avatar_outline?.outline_width === "2px"
                  ? "border-2"
                  : "border"
              } border-${
                stylesColoumValue?.avatar_outline?.outline_style
              } border-[${stylesColoumValue?.avatar_outline?.outline_colour}]`
            : ""
        }`}
        src={`${
          coloumValue?.name ? baseUrl + "/profile/" + coloumValue?.name : ""
        }`}
        
        alt="avatar" title="Avatar"
       />
    </div>
  );
};

export default AvatarCard;
